// Polyfills first
import 'react-app-polyfill/ie11'; // For IE 11 support
import 'react-app-polyfill/stable';
import 'core-js';
import './polyfill';

// React & libs
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import App from './App';
import * as serviceWorker from './serviceWorker';

// Redux setup
import { applyMiddleware, createStore } from 'redux';
import { rootReducer } from './redux/rootReducer';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';

// Polyfills for Node core modules (must be imported before usage)
import { Buffer } from 'buffer';
import process from 'process';

// Init store
export const store = createStore(
  rootReducer,
  composeWithDevTools(applyMiddleware(thunk))
);

// Attach globals
if (!window.Buffer) window.Buffer = Buffer;
if (!window.process) window.process = process;

// Render app
ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);

// Service worker
serviceWorker.unregister();
